import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/one-vigilance/qms-psmf-services")({
  head: () => buildRouteHead("/en/services/one-vigilance/qms-psmf-services", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/services/pharmacovigilance/qms-psmf-services", replace: true });
  },
});
